import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Home, Users, Phone, Mail, MapPin, ChevronRight, FileText,
  Sparkles, Building2, LogIn, ExternalLink
} from 'lucide-react';
import './LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className={`landing-page gateway ${isVisible ? 'visible' : ''}`}>
      <div className="gateway-container">
        {/* Keel Group Parent Brand */}
        <div className="gateway-header">
          <h1 className="keel-group-title">Keel Group</h1>
          <div className="keel-group-divider"></div>
        </div>

        {/* Two Business Branches */}
        <div className="gateway-brands">
          <div className="brand-card sisters">
            <div className="brand-card-icon">
              <Sparkles size={28} />
            </div>
            <h2 className="brand-card-name">Two Sisters</h2>
            <p className="brand-card-full">Cleaning & Organizing</p>
            <p className="brand-card-desc">Residential cleaning, deep cleans, and organizing services</p>
            <div className="brand-card-actions">
              <button
                className="brand-card-btn"
                onClick={() => navigate('/portal')}
              >
                <Home size={16} />
                Client Portal
              </button>
              <a
                href="https://twosisterscleaningco.com"
                target="_blank"
                rel="noopener noreferrer"
                className="brand-card-link"
              >
                <ExternalLink size={14} />
                Website
              </a>
            </div>
          </div>

          <div className="brand-card commercial">
            <div className="brand-card-icon">
              <Building2 size={28} />
            </div>
            <h2 className="brand-card-name">Keel Commercial</h2>
            <p className="brand-card-full">Services</p>
            <p className="brand-card-desc">Commercial cleaning and facility maintenance solutions</p>
            <div className="brand-card-actions">
              <button
                className="brand-card-btn"
                onClick={() => navigate('/portal')}
              >
                <Home size={16} />
                Client Portal
              </button>
              <button
                className="brand-card-link"
                onClick={() => navigate('/commercial')}
              >
                <ExternalLink size={14} />
                Learn More
              </button>
            </div>
          </div>
        </div>

        {/* Team Login - Prominent */}
        <button
          className="gateway-team-login"
          onClick={() => navigate('/login')}
        >
          <LogIn size={20} />
          Team Login
          <ChevronRight size={18} />
        </button>

        {/* New Customer CTA */}
        <div className="gateway-new-customer">
          <span>Looking for a quote?</span>
          <a
            href="https://keelgroup.app/quote"
            className="gateway-quote-link"
          >
            <FileText size={18} />
            Request a Quote
          </a>
        </div>

        {/* Contact Info */}
        <div className="gateway-footer">
          <a href="tel:+14342072246" className="gateway-contact">
            <Phone size={16} />
            (434) 207-2246
          </a>
          <a href="mailto:sales@twosisterscleaningco.com" className="gateway-contact">
            <Mail size={16} />
            sales@twosisterscleaningco.com
          </a>
          <span className="gateway-contact">
            <MapPin size={16} />
            Charlottesville, VA
          </span>
        </div>

        <p className="gateway-copyright">
          © {new Date().getFullYear()} Keel Group
        </p>
      </div>
    </div>
  );
}

export default LandingPage;
